import React from "react";
import { Helmet } from "react-helmet";
import "./styles.css";
import SportEventCalendarApp from "./App";

/**
 * Render react app with redux store
 */
interface IProps {
  selectedCountry: string;
}

const SportEventCalendar: React.FC<IProps> = ({ selectedCountry }) => {
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sports Calendar</title>
      </Helmet>
      <SportEventCalendarApp />
    </React.Fragment>
  );
};

export default SportEventCalendar;
